import React from 'react';
import Menu from './Menu'; // Import your Menu component
import Cart from './Cart'; // Import your Cart component
import CheckoutForm from './CheckoutForm';
import ContinueShopping from './ContinueShopping'; // Import the ContinueShopping component
import Home from './Home'; // Import the Home component
import './CartAndCheckout.css'; // Import the CSS file for styling
import Navbar from './layout/Navbar'; 
const CartAndCheckout = () => {
    return (
        <div>
            <Navbar />
            <div className="cart-checkout-container">
                <CheckoutForm />
                <Cart />
            </div>
            <ContinueShopping /> {/* Include the Continue Shopping button */}
            <Home /> {/* Include the Home component here */}
        </div>
    );
};

export default CartAndCheckout;
